/**
 * @generated SignedSource<<a4206fd5d301adb469af3561c0903893>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioPeriod = "DAY" | "MAX" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type PortfolioSummaryQuery$variables = {
  period: PortfolioPeriod;
};
export type PortfolioSummaryQuery$data = {
  readonly portfolio: {
    readonly overallAmount: PrecisionFloat | null | undefined;
    readonly returnPercentage: number | null | undefined;
  } | null | undefined;
};
export type PortfolioSummaryQuery = {
  response: PortfolioSummaryQuery$data;
  variables: PortfolioSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "period"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "period",
            "variableName": "period"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Portfolio",
    "kind": "LinkedField",
    "name": "portfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overallAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnPercentage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioSummaryQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PortfolioSummaryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c686741576a35261f1a84f705a598d2",
    "id": null,
    "metadata": {},
    "name": "PortfolioSummaryQuery",
    "operationKind": "query",
    "text": "query PortfolioSummaryQuery(\n  $period: PortfolioPeriod!\n) {\n  portfolio(input: {period: $period}) {\n    overallAmount\n    returnPercentage\n  }\n}\n"
  }
};
})();

(node as any).hash = "2103fca9800a18cf6710e48d9f9b9ed8";

export default node;
